import React from "react";
import { Link } from "react-router-dom";

export const PageNotFound: React.FC = () => {
  return (
    <div className="space-y-4 text-center">
      <h2 className="text-2xl font-semibold tracking-tight">Page not found</h2>
      <p className="text-sm text-slate-400">
        The page you are looking for does not exist.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-full bg-slate-50 px-4 py-2 text-sm font-medium text-slate-900 hover:bg-slate-200"
      >
        Go back home
      </Link>
    </div>
  );
};

export default PageNotFound;

